@if (editSection) {
	<nz-card>
		<form [formGroup]="form">
			<div>
				<app-language-selector (onChange)="onLanguageChange($event)"></app-language-selector>
			</div>
			<nz-form-item>
				<nz-form-label>Section Name</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="name" />
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label>Location</nz-form-label>
				<app-location-field
					[fg]="form"
					[client]="adminService.selectedClient$ | async"
					formGroupOrControlName="locationUuid"
				></app-location-field>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label>Active Start Date</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="activeStartDate"></nz-date-picker>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label>Active End Date</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="activeEndDate"></nz-date-picker>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-control>
					<label nz-checkbox formControlName="active">Is Active</label>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-control>
					<label nz-checkbox formControlName="allowSelfRostering">Allow Self-Rostering</label>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item
				nz-tooltip="Demo sections allow teachers to see all student data, but not other teachers' data. Additionally when users self-roster they will have teacher role."
			>
				<nz-form-control>
					<label nz-checkbox formControlName="isDemo">Is Demo</label>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label>SSO Section ID</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="ssoSectionId" />
				</nz-form-control>
			</nz-form-item>

			<div class="buttons">
				<button nz-button nzType="primary" (click)="save(); $event.preventDefault()" title="Save">
					<span nz-icon nzType="save" nzTheme="outline"></span>
					Save
				</button>
				<button nz-button (click)="clear(); $event.preventDefault()" title="Clear">Clear</button>
			</div>
		</form>
	</nz-card>
}
